/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store.js';
import axios from 'axios'
import Es6Promise from 'es6-promise'
import commonFuc from '@/utils/commonFuc.js'
import api from '@/api/index'
Vue.config.productionTip = false;

Vue.prototype.$tool = commonFuc;
Es6Promise.polyfill();
console.log(process.env.VUE_APP_URL)
axios.defaults.baseURL = process.env.VUE_APP_URL
axios.defaults.headers['version'] = process.env.VUE_APP_VERSION

// 获取服务器时间
commonFuc.getNowTime();

const paramsInit = async ()=>{
  if(window.isDomain){//当前是独立域名
    let res = await await api.getOrgInfo({adminUrl:window.location.hostname})
    if(res){
      window.adminUrl = res.adminUrl//当前是独立域名并且域名可用（带HTTPS）
      window.rentId = res.id
    }
  }
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}
paramsInit()
